/* globals jQuery */
import 'fitvids.1.1.0'
import 'magnific-popup'
import objectFitImages from 'object-fit-images';
import responsiveNav from './responsive-nav.jquery.js'
import { throttle, debounce } from 'throttle-debounce';
import accordion from './jquery.accordion.js'
import './slideshows.js'
import './effects.js';

(($) => {

    $.fn.responsiveNav = responsiveNav
    $.fn.accordion = accordion

    //polyfill for IE object-fit on images
    var $objectFit = $('img.object-fit');
    objectFitImages($objectFit);

    // Make nav menu nice & responsive
    $('nav.main-nav').responsiveNav({
        navType: 'dropdown', //default option for dropdown type use 'dropdown'
        closeOnOutsideClick: false, //set to false if using dropdown type
        showTabsOnFocus: true,
    });

    // Responsive Videos
    $('.rtecontent, .video').fitVids();

    // Accordions
    $('dl.accordion').accordion();

    $('.js-inline-popup').magnificPopup({
        type:'inline',
        midClick: true
    });

    //comment icon linking to comment section
    $('.sticky-comments__icon').on('click',function(e){
        e.preventDefault();
        $('html, body').animate({
                scrollTop: $("#commentSection").offset().top
        }, 1000);
    });


    //mmh category filtering
	var $mmhCatsDropdown = $('select#mmhCats');
	$mmhCatsDropdown.change(function(){
		window.location.href = $mmhCatsDropdown.val();
	});

    //pervious change agent winners year filtering
	var $caYearDropdown = $('select#pastWinnersYear');
	$caYearDropdown.change(function(){
		window.location.href = $caYearDropdown.val();
	});

    // Scroll to top of page button
    const button_top = document.getElementById("js-btn-top");
    if( button_top ){
        // user scrolls down 20px from the top of the document, show the button
        window.onscroll = function() {scrollFunction()};
        function scrollFunction() {
            if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
                button_top.style.display = "block";
            } else {
                button_top.style.display = "none";
            }
        }

        // user clicks on the button, scroll to the top of the document
        $('#js-btn-top').on('click',function(e){
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        });
    }

    //SEARCH POPUP
    $('.js-open-search').magnificPopup({
        type:'inline',
        alignTop: true,
        modal: true,
        midClick: true, // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
        mainClass: 'mfp-fade',
        focus : '#s',
        callbacks: {
            // When elemened is focused, some mobile browsers in some cases zoom in
            // It looks not nice, so we disable it:
            beforeOpen: function() {
                if($(window).width() < 700) {
                    this.st.focus = false;
                } else {
                    this.st.focus = '#s';
                }
            }
        }
    });
    $(document).on('click', '.js-close-search', function (e) {
        e.preventDefault();
        $.magnificPopup.close();
    });
    /* END SEARCH CONTROLS */

    //Video popup
    $('.js-popup-video').magnificPopup({
        type:'inline',
        alignTop: true,
        modal: true,
        midClick: true, // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
        mainClass: 'mfp-fade',
    });
    $(document).on('click', '.js-close-video', function (e) {
        e.preventDefault();
        $.magnificPopup.close();
    });

    /*
        Voting for Post
        Used for on Change Agent posts and MMH posts
        For each js-vote button check for cookie that vote has already happened, 
        if it hasn't show the button
    */
	$('button.js-vote').each(function() {
		var post_id = $(this).data('post-id');
		var hash = $(this).data('hash');
		var strExpires = $(this).data('exp');
		var voted = document.cookie.indexOf('safeco_agent_giving_voted_' + post_id + '='+hash) > -1;

		if (voted === true) {
			disableVoteBtn($(this));
		}
		$(this).removeClass('hide');
	});

    /*
        Voting for Post
        Used for on Change Agent posts and MMH posts
        When vote button is clicked, incrememnt vote count field and display new count
        set a cookie to disable additional voting
    */
	$('button.js-vote').on('click', debounce(300, function(){
		
		var btn = $(this);
		var post_id = $(this).data('post-id');
        var post_type = $(this).data('posttype');
		var hash = $(this).data('hash');
		var strExpires = $(this).data('exp');

		$.ajax({
			type: "POST",
			dataType: "json",
			url: vote_ajax_script.ajaxurl,
			data: {
				action: 'register_vote',
				post_id: post_id,
                post_type: post_type
			},
			success: function (json) {
				if (json.success === true) {
					var voteCountText = json.count + " Vote";
					if (parseInt(json.count) !== 1) {
						voteCountText += 's';
					}
                    $('.icon-heart svg').addClass('heart-beat');
					$('span.vote-count').html(voteCountText);
					document.cookie = 'safeco_agent_giving_voted_' + post_id + '=' + hash + '; expires={' + strExpires + '}';
					disableVoteBtn();
				}
			},
			error: function (jqXHR, textStatus, errorThrown) {
				alert ("We were unable to record your vote. Please try again.");
			}

		});

	}));

	function disableVoteBtn() {
        $('button.js-vote').each(function(){
            $(this).unbind('click');
            $(this).removeClass('js-vote');
            $(this).addClass('btn--disabled');
            $(this).find('span').first().html('Thanks for voting');
        });
	}

    // Function used to hide the wpDizcus comment form and show a thank you message
    window.mmhHideCommentsForm = () => {
        $('#commentSection .wpd-form-wrap').addClass('hide');
        $('#mmhCommentSubmittedMessage').removeClass('hide');
    };
    // Custom AJAX callback for comments added to Make More Happen posts
    window.mmhCommentSubmittedCallback = (response) => {
        if (response.success) {
            window.mmhHideCommentsForm();
            const commentDiv = $('#commentSection');
            const postID = commentDiv.data('post-id');
            const hash = commentDiv.data('hash');
            const strExpires = commentDiv.data('exp');
            document.cookie = 'safeco_agent_giving_commented_' + postID + '=' + hash + '; expires={' + strExpires + '}';
        }
    };

    // Hide Make More Happen comment form if the user has previously commented and the cookie still exists
    $('.single-post #commentSection').each(function() {
        const postID = $(this).data('post-id');
        const hash = $(this).data('hash');
        const commented = document.cookie.indexOf('safeco_agent_giving_commented_' + postID + '='+hash) > -1;

        if (commented === true) {
            window.mmhHideCommentsForm();
        }
    });

})(jQuery)
